// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"-BlIHYE","h5Text":"_2UzUTyy","h4Text":"_MVzwwY","h3Text":"nHYBemR","srOnly":"_1LUDXor","link":"_1apYCvh -BlIHYE","minibagFooter":"QkVPNga"};